if ( typeof AnnouncementBar !== 'function' ) {

  /* RC #24 (Nana 8/10): begge pile virker hele tiden og går rundt (sidste -> første, første -> sidste).
     Udgangspunktet læses fra sliderens faktiske scroll-position ved hvert klik, så pilene følger med,
     når kunden swiper beskederne på mobil (før stod pilene fast på den første besked). */
  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.pending = null;

      [this.nextButton, this.prevButton].forEach(button => {
        if ( button ) button.classList.remove('announcement-bar__content-nav--disabled');
      });

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
        });
      }

      if ( this.slider ) {
        this.slider.addEventListener('scroll', ()=>{
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(()=>{
            if ( this.pending === null ) this.index = this.currentIndex();
          }, 150);
        }, { passive: true });
      }

    }

    slideLeft(i) {
      return this.content[i].offsetLeft - this.slider.offsetLeft;
    }

    currentIndex() {
      const position = Math.abs(this.slider.scrollLeft);
      let best = 0;
      let distance = Infinity;
      for ( let i = 0; i < this.length; i++ ) {
        const d = Math.abs(Math.abs(this.slideLeft(i)) - position);
        if ( d < distance ) {
          distance = d;
          best = i;
        }
      }
      return best;
    }

    changeSlide(direction) {

      if ( ! this.slider || this.length < 2 ) return;

      // Et klik midt i en glidende animation regner fra målet, ikke fra halvvejs-positionen.
      const from = this.pending !== null ? this.pending : this.currentIndex();
      const step = direction == 'prev' ? -1 : 1;

      this.index = ( from + step + this.length ) % this.length;
      this.pending = this.index;

      this.slider.scrollTo({
        top: 0,
        left: this.slideLeft(this.index),
        behavior: 'smooth'
      });

      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(()=>{
        this.pending = null;
        this.index = this.currentIndex();
      }, 800);

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
	}

}
